import { render } from "./ProductCategoryShow.vue?vue&type=template&id=f1a699ee&scoped=true"
import script from "./ProductCategoryShow.vue?vue&type=script&lang=js"
export * from "./ProductCategoryShow.vue?vue&type=script&lang=js"

import "./ProductCategoryShow.vue?vue&type=style&index=0&id=f1a699ee&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a699ee"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ProductCategoryShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1a699ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1a699ee', __exports__)) {
    api.reload('f1a699ee', __exports__)
  }
  
  module.hot.accept("./ProductCategoryShow.vue?vue&type=template&id=f1a699ee&scoped=true", () => {
    api.rerender('f1a699ee', render)
  })

}


export default __exports__